/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_S7_TitleInputs */

const en_fc_tut_s7_title = /** @type {(inputs: Fc_Tut_S7_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add effects, transitions and keyframes`)
};

/**
* | output |
* | --- |
* | "Add effects, transitions and keyframes" |
*
* @param {Fc_Tut_S7_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_s7_title = /** @type {((inputs?: Fc_Tut_S7_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_S7_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_s7_title(inputs)
});
export { fc_tut_s7_title as "fc.tut.s7.title" }